import { Action, createReducer, on } from '@ngrx/store';
import { saveTowAttemptFailure, saveTowAttemptRequest, saveTowAttemptSuccess } from './actions';
import { adapter, initialState, State } from './state';

export const towAttemptReducer = createReducer(
    initialState,
    on(
        saveTowAttemptRequest,
        state => ({
            ...state,
            loading: true,
            error: null
        })
    ),
    on(
        saveTowAttemptFailure,
        (state, { error }) => ({
            ...state,
            loading: false,
            error
        })
    ),

    // Save
    on(
        saveTowAttemptSuccess,
        (state, { towAttempt }) => adapter.upsertOne(towAttempt, {
            ...state,
            loading: false,
            error: null
        })
    )
);

export function reducer(state: State, action: Action) {
    return towAttemptReducer(state, action);
}
